import {
    memo,
    lazy,
    Suspense,
    useMemo,
} from 'react';
import { useWindowSize } from '@react-hook/window-size';

import { screenSizes } from '_constants/mediaOptions';
import { TranslationProvider } from 'contexts/useTranslationContext';

const FooterComponents = {
    desktop: lazy(() => import('./DesktopFooter')),
    mobile: lazy(() => import('./MobileFooter')),
};

const CurrentFooter = memo(({ type }) => {
    const Component = FooterComponents[type];

    return <Component />;
});

const Footer = () => {
    const [windowWidth] = useWindowSize();
    const footerType = useMemo(
        () => (screenSizes.md > windowWidth ? 'mobile' : 'desktop'),
        [windowWidth],
    );

    return (
        <TranslationProvider>
            <Suspense fallback={<></>}>
                <CurrentFooter type={footerType} />
            </Suspense>
        </TranslationProvider>
    );
};

export default memo(Footer);
